export default "__VITE_ASSET__DdwcgEUc__"